import React, { useState } from 'react';
import { useCouponContext } from '../../../../contexts/CouponContextProvider';
import { CouponModal } from '@jbhi-fi/components/src/CouponModal';
import { Portal } from '../../../../components/portal/Portal';
import {
  BIRTHDAY_COUPON_REFERENCE,
  SIGNUP_COUPON_REFERENCE,
} from '../../../../contexts/CouponContextProvider/constants';
import { useCouponTracking } from '../../../../hooks/useCouponTracking/useCouponTracking';

export const CouponsModalWrapper = () => {
  const [isCouponAnimationPlaying, setIsCouponAnimationPlaying] = useState(false);
  const {
    isCouponSurfacingEnabled,
    isLoading,
    isModalOpen,
    selectedCoupon,
    handleDeselectCoupon,
    handleApplyCoupon,
    handleRemoveCoupon,
  } = useCouponContext({});
  const { trackCouponEvent } = useCouponTracking(selectedCoupon);
  const handleOnClose = () => {
    handleDeselectCoupon();
    trackCouponEvent({ type: 'close_popup' });
    setIsCouponAnimationPlaying(false);
  };
  const handleOnRemoveCoupon = async (couponCode: string) => {
    await handleRemoveCoupon(couponCode);
    setTimeout(() => {
      handleDeselectCoupon();
    }, 5000);
    setIsCouponAnimationPlaying(false);
  };
  const handleApplyCouponAnimation = async () => {
    await handleApplyCoupon();
    const couponName = selectedCoupon?.couponName.toUpperCase();
    const isPerksBirthdayOrWelcomeCoupon =
      couponName?.includes(BIRTHDAY_COUPON_REFERENCE) || couponName?.includes(SIGNUP_COUPON_REFERENCE);
    if (isPerksBirthdayOrWelcomeCoupon) {
      setIsCouponAnimationPlaying(true);
    } else {
      setTimeout(() => {
        handleDeselectCoupon();
      }, 5000);
      setIsCouponAnimationPlaying(false);
    }
  };
  if (!isCouponSurfacingEnabled) return null;
  const container = document.body;

  return isModalOpen && selectedCoupon ? (
    <Portal container={container}>
      <CouponModal
        isOpen={isModalOpen}
        coupon={selectedCoupon}
        onApplyCoupon={handleApplyCouponAnimation}
        onRemoveCoupon={handleOnRemoveCoupon}
        onClose={handleOnClose}
        isLoading={isLoading}
        playCouponAppliedAnimation={isCouponAnimationPlaying}
      />
    </Portal>
  ) : null;
};
